/* global setGaqPush */
import commentReviews from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/commentReviews';
import fetchStateFromHtml from '@PROJECT_ROOT/assets/shared/js/fetchStateFromHtml';
import openModal from '@PROJECT_ROOT/assets/shared/js/modalBox';
import verticalSmoothScrollToPosition from '@PROJECT_ROOT/assets/desktop/js/library/verticalSmoothScrollToPosition';
import { isFrame } from '@PROJECT_ROOT/assets/shared/js/isPartnerService';
import { unitCompareToggleButton } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Compare';
import { unitFavoriteToggleButton } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Favorites';
import { urlChanged } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';

$(() => {
    const state = fetchStateFromHtml();

    scrollToComments();
    commentReviews(state);
    initUnitTabs(state);
    initializeUnitTabsMapDialogInModalBox();

    if (window.location.hash === '') {
        // ako je zadan nekakav hash ne vršimo scroll na jedinice
        setTimeout(scrollToUnits, 1000);
    }
});

function scrollToUnits() {
    const $presentation = $('.presentation');

    if ($presentation.length) {
        const unitsPosition = $('.unitsMenuBar').offset().top - 20;

        if (!window.local_vac_html && !window.local_vac_frame) {
            verticalSmoothScrollToPosition($('html, body'), unitsPosition, 1300);
        }
    }
}

// Klik na ikonicu ocjene u naslovu objekta, vrši scroll na sekciju komentara
function scrollToComments() {
    const presentation = document.querySelector('.presentation');
    const comments = document.querySelector('.comments');
    const totalRating = document.querySelector('.facilityRating');

    if (presentation && comments && totalRating) {
        totalRating.addEventListener('click', (e) => {
            const commentsPosition = $('.js-ratingSection').offset().top;
            e.preventDefault();
            verticalSmoothScrollToPosition($('html, body'), commentsPosition, 1750);
        });
    }
}

function initUnitTabs(state) {
    const unitsMenuBar = $('.unitsMenuBar');
    let cachedUnit;

    unitsMenuBar.on('click', 'li', function unitsMenuBarClick(e) {
        // return if the clicked unit is the current active
        if ($(this).hasClass('active')) { return false; }

        if (!$(this).hasClass('menuOtherUnits')) {
            e.preventDefault();

            const clickedA = e.currentTarget.querySelector('a');
            const newUrl = clickedA?.dataset?.hadHref || clickedA.href;
            window.parent.postMessage(urlChanged(newUrl), '*');

            if (window.requestList.unit && window.requestList.unit.readyState !== 4) {
                window.requestList.unit.abort();
            }
            if (window.requestList.pReservation && window.requestList.pReservation.readyState !== 4) {
                window.requestList.pReservation.abort();
            }

            if (window.intervalCalculationID) { clearInterval(window.intervalCalculationID); }

            unitsMenuBar.find('.active').removeClass('active');
            $(this).addClass('active');

            cachedUnit = unitsMenuBar.data($(this).data('unit_id').toString());
            if (cachedUnit) {
                $('#privatePresentationUnit')
                    .html(cachedUnit.unitDetails)
                    .find('.tooltip')
                    .tooltip({
                        track: true,
                        position: { my: 'left+20 top+10', at: 'right bottom', collision: 'flipfit' },
                    });
                document.title = cachedUnit.title;
                initializeEventsOnUnitTab(state);
            } else {
                $('#unitOpacity').show();
                window.requestList.unit = $.getJSON(
                    $(this).data('unit_details_url'),
                    { form_url: $(this).children('a').prop('href') },
                );

                window.requestList.unit.then((response) => {
                    $('#unitOpacity').hide();
                    $('#privatePresentationUnit')
                        .html(response.unitDetails)
                        .find('.tooltip')
                        .tooltip({
                            track: true,
                            position: { my: 'left+20 top+10', at: 'right bottom', collision: 'flipfit' },
                        });

                    document.title = response.title;
                    unitsMenuBar.data($(this).data('unit_id').toString(), response);
                });

                window.requestList.unit.then(() => {
                    initializeEventsOnUnitTab(state);
                });
            }

            // change selected checkbox on unit change
            $('#unitSelection').find('input[id*=units]').prop('checked', false);
            $('#unitSelection').find(`input[id$=units_${$(this).data('unit_id')}]`).prop('checked', true);
        }

        // clear "similar accomodation"
        $('#tabNearby').click();
        if ($('#tabSimilarAcc').data('loaded')) {
            $('#tabSimilarAcc').data('loaded', false);
            $('#similarAccUnits').empty().addClass('similarAccLoaderWrap');
        }

        return true;
    });
}

function clearCachedUnits() {
    $('.unitsMenuBar').removeData();
}

function initializeEventsOnUnitTab(state) {
    unitCompareToggleButton({
        onAdd: clearCachedUnits,
        onRemove: clearCachedUnits,
    });
    unitFavoriteToggleButton({
        onAdd: clearCachedUnits,
        onRemove: clearCachedUnits,
    });
    commentReviews(state);
}

/**
 * Postavlja tab dialog google mape (makrolokacije, udaljenosti i plaže) u modal box.
 */
function initializeUnitTabsMapDialogInModalBox() {
    const openDialogButtons = document.querySelectorAll('.js-openPoiDialogButton');

    openDialogButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();

            const url = button.href;
            const frame = document.createElement('iframe');
            frame.width = '940px';
            frame.height = button.getAttribute('data-frameHeight');
            frame.src = url;

            openModal(frame, {
                modalContentCss: isFrame() ? ['modal-box__container_full-width'] : ['tabOpenPoiDialog'],
            });
            setGaqPush('Object', 'Poi', button.getAttribute('data-googleEventLabel'));
        });
    });
}
